import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GroupKeyMember } from '../../services/financial-planning.service';


@Component({
  selector: 'app-add-group-key-member',
  templateUrl: './add-group-key-member.component.html',
  styleUrls: ['./add-group-key-member.component.scss']
})
export class AddGroupKeyMemberComponent implements OnInit {

  @Input() groupKey: string | undefined;

  @ViewChild('newOrgCode') newOrgCode: any | undefined;
  @ViewChild('newPropertyCode') newPropertyCode: any | undefined;

  @Output('hide') hide: EventEmitter<any> = new EventEmitter();
  @Output('save') save: EventEmitter<any> = new EventEmitter<GroupKeyMember>();

  errormessage = '';
  constructor() { }

  ngOnInit(): void {
    this.errormessage = '';
  }


  fieldChanged(elem: HTMLInputElement) {
      this.errormessage = '';
  }

  addNewMember() {
    if(!(this.newOrgCode && this.newOrgCode.nativeElement.value)) {
      this.errormessage = 'OrgCode required';
      return;
    }

    if(!(this.newPropertyCode && this.newPropertyCode.nativeElement.value)) {
      this.errormessage = 'Property Code required';
      return;
    }

    const newGroupKeyMember: GroupKeyMember = {
      groupKey: this.groupKey,
      orgCode: this.newOrgCode.nativeElement.value,
      propertyCode: this.newPropertyCode.nativeElement.value
    };

    this.save.emit(newGroupKeyMember);
  }

  cancelAddNewMember() {
    this.hide.emit();
  }
}
